<style>
.ivu-radio-group{
  display: block;
  margin-bottom: 10px;
}
</style>
<template>
	<Layout>
		<header style="margin-bottom: 0px;"><Button @click="$router.push('/common/couponList');">返回</Button></header>
		<Content :style="{'padding': '10px'}">
			<Breadcrumb :style="{margin: '5px 0'}">
				<BreadcrumbItem>通用管理 > <b>优惠券领取记录</b></BreadcrumbItem>
			</Breadcrumb>
			<Card :style="{'padding':'0px 5px','margin-bottom':'5px'}">
				<span class="search_span_width">
					<span class="search_span_width_part1">用户ID：</span>
					<Input v-model="search.user_id" placeholder="请输入用户ID" :style="{'width':'110px'}"></Input>
				</span>
				<span class="search_span_width">
					<span class="search_span_width_part1">&nbsp;&nbsp;状态：</span>
					<Select v-model="search.status" clearable style="width:130px">
						<Option value="">请选择</Option>
						<Option value="1">未使用</Option>
						<Option value="2">已使用</Option>
						<Option value="3">已过期</Option>
					</Select>
				</span>
				<Button type='primary' icon="ios-search" :style="{'margin-left':'20px'}" @click="getList(1)">搜索</Button>
			</Card>
			<Card>
				<Card id="tableContent" >
					<Table :columns="tableColumns" row-key="id" update-show-children :data="recordList"></Table>
					<Page :total="recordTotal" :current="page" :page-size="10" :show-elevator="true" @on-change="getList"/>
				</Card>
			</Card>
		</Content>
	</Layout>
</template>
<script>
export default {
	data(){
		return {
			coupon_id:0,
			search:{
				user_id:"",
				status:"",
			},
			showmodal:false,
			channelList:[],
			recordList:[],
			recordTotal:0,
			page:1,
			tableColumns:[
				{ title: 'ID', key: 'id', align: 'center' },
				{ title: '优惠券ID', key: 'coupon_id', align: 'center' },
				{ title: '用户ID', key: 'user_id', align: 'center' },
				{ title: '用户昵称', key: 'user_nickname', align: 'center' },
				{ title: '生效时间', key: 'start_time', align: 'center'},
				{ title: '失效时间', key: 'end_time', align: 'center'},
				{ title: '使用时间', key: 'use_time', align: 'center',
					render:(h,params) =>{
						if (params.row.use_time == 0) {
							var use_time = '-';
						}else {
							var use_time = params.row.use_time;
						}
						return h('span',{},use_time);
					}
				},
				{ title: '状态', key: 'status', align: 'center',
					render:(h,params) =>{
						if (params.row.status == 2) {
							var status = '已使用';
						} else if (params.row.status == 3) {
							var status = '已过期';
						} else {
							var status = '未使用';
						}
						return h('span',{},status);
					}
				},
				/*{ title: '所属渠道', key: 'channel_name', align: 'center'},*/
				{ title: '操作', key: 'action', align: 'center',
					render: (h, params) => {
						let btns = []
						btns.push(
							h('Button', {
								props: { type: 'error', size: 'small' },
								style: { marginRight: '5px', marginBottom: '5px'},
								on: {
									click: () => {
										this.del(params.row.id);
									}
								}
							}, '删除'),
						);
						return h("div", btns);
					}
				}
			],
		}
	},
	mounted:function(){
		this.coupon_id = this.$route.query.coupon_id ? this.$route.query.coupon_id : 0;
		this.getChannelList();
		this.getList();
	},
	computed:{},
	methods:{
		getChannelList(){
			this.http1.get('/coupon/channelList').then(response=>{
				let data = response.data;
				if (data.code !== 0) {
					alert(data.message);
				} else {
					if (data.data) {
						this.channelList = data.data;
					}
				}
			}).catch(()=>{
				this.$Message.error('网络错误');
			});
		},
		getList(page = this.page){
			this.page = page;
			let p = {'coupon_id':this.coupon_id, 'page':page};
			let params = Object.assign(this.search, p);
			this.http1.get('/coupon/userCouponList', {params:params}).then(response=>{
				let data = response.data;
				if (data.code !== 0){
					alert(data.message);
				} else {
					this.recordList = data.data.list;
					this.recordTotal = data.data.total;
				}
			}).catch(()=>{
				this.$Message.error('网络错误');
			});
		},
		del(id){
			this.$Modal.confirm({
				content: '<p>请确认是否删除用户该优惠券？</p>',
				onOk: () => {
					this.showAllmodal = false;
					this.http1.post('/coupon/delUserCoupon', {id:id}).then(response=>{
						let data = response.data;
						if (data.code !== 0) {
							this.$Message.error(data.message);
							return false;
						} else {
							this.$Message.info('删除成功');
							this.getList(this.page);
							return true;
						}
					}).catch(()=>{
						this.$Message.error('网络错误');
					});
				},
			});
		},
	}
}
</script>
